import Link from './Link'

const NotFound = () => {
  return (
    <main className="flex min-h-screen items-center bg-white">
      <div className="container mx-auto px-4 py-32 text-center">
        <p className="text-sm font-semibold uppercase tracking-[0.24em] text-teal-700">Error 404</p>
        <h1 className="mt-4 text-4xl font-semibold text-slate-950 md:text-5xl">
          This page could not be found.
        </h1>
        <p className="mx-auto mt-5 max-w-xl text-lg leading-8 text-slate-600">
          The page may have been moved or no longer exists. Browse our prosthetic and rehabilitation
          product categories instead.
        </p>
        <Link
          to="/"
          className="mt-8 inline-block rounded-md bg-slate-950 px-7 py-3 text-sm font-semibold text-white transition-colors hover:bg-teal-700"
        >
          Back to homepage
        </Link>
      </div>
    </main>
  )
}

export default NotFound
